import { api } from './client.js';

export interface VaultPayload {
  title: string;
  content: string;
  attachments: unknown[] | null;
}

export interface VaultStatus {
  unlocked: boolean;
}

export interface EncryptResult {
  ciphertextBase64: string;
}

export interface DecryptResult {
  payload: VaultPayload;
}

export interface DecryptBytesResult {
  dataBase64: string;
}

export interface EncryptBytesResult {
  ciphertextBase64: string;
}

/** A vault attachment manifest, stored inside the note's encrypted payload. */
export interface VaultAttachmentManifest {
  originalRelativePath: string;
  encryptedName: string;
}

export const vaultApi = {
  status: () => api.get<VaultStatus>('/vault/status'),

  /**
   * A 401 here means the vault password was wrong — it must not be treated as
   * an expired app session, hence `ignoreUnauthorized`.
   */
  unlock: (password: string) =>
    api.post<{ ok: true }>('/vault/unlock', { password }, { ignoreUnauthorized: true }),

  lock: () => api.post<{ ok: true }>('/vault/lock'),

  decrypt: (ciphertextBase64: string) =>
    api.post<DecryptResult>('/vault/decrypt', { ciphertextBase64 }),

  encrypt: (payload: VaultPayload) => api.post<EncryptResult>('/vault/encrypt', { payload }),

  /** Vault attachments are raw AES-GCM blobs, not JSON. */
  decryptBytes: (ciphertextBase64: string) =>
    api.post<DecryptBytesResult>('/vault/decrypt-bytes', { ciphertextBase64 }),

  encryptBytes: (dataBase64: string) =>
    api.post<EncryptBytesResult>('/vault/encrypt-bytes', { dataBase64 }),
};
